module.exports = __webpack_public_path__ + "assets/media/dizzy-robot.f3ca71cf.svg";